export default __webpack_public_path__ + "static/media/logoLine.5e6f96a8.webp";